import React, { useContext, useEffect, useState } from 'react';
import { ApiContext } from '@api/api';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { DocumentTypeEnum, LovDocumentTypeOutDTO } from '@api/ringil-api.v2';

interface ComponentProps {
  documentType: DocumentTypeEnum;
  placeholder?: string;
  style?: any;
  onChange: (documentType: LovDocumentTypeOutDTO) => void;
  /** A search field above the list, for picking from many types by name. */
  filter?: boolean;
}

export const InputDocumentType: React.FC<ComponentProps> = ({ documentType, placeholder, onChange, style, filter = false }) => {
  const { lovAttachmentDocumentType } = useContext(ApiContext);
  const [items, setItems] = useState<LovDocumentTypeOutDTO[]>([]);

  useEffect(() => {
    lovAttachmentDocumentType(d => {
      setItems(d);
    });
  }, []);

  return (
    <>
      <Dropdown
        style={style}
        value={{ documentType }}
        options={items}
        dataKey={'documentType'}
        optionLabel={'name'}
        placeholder={placeholder}
        className="custom-pr-dropdown"
        filter={filter}
        filterBy="name"
        onChange={e => {
          onChange(e.value);
        }}
      />
    </>
  );
};
